import ProgressStripeBar from '@/components/ProgressStripeBar';
import { UsageCellRoot } from './styles';

type UsageCellProps = {
  rate: number;
};

const UsageCell = ({ rate }: UsageCellProps) => (
  <UsageCellRoot>
    <ProgressStripeBar className="bar" percent={[Math.max(rate, 0)]} />
    <span>{rate}%</span>
  </UsageCellRoot>
);

export default UsageCell;
